import { Badge } from '@mlm/ui';
import type { ExpiryBucket } from '../../lib/api';
import { daysLeftLabel } from './lot-bits';

/** How urgent a lot's expiry is, as a coloured badge. */
export function ExpiryBadge({
  bucket,
  daysLeft,
}: {
  bucket: ExpiryBucket;
  daysLeft: number | null;
}) {
  if (bucket === 'none') return <span className="text-xs text-muted-foreground">No expiry</span>;
  const variant =
    bucket === 'expired'
      ? 'destructive'
      : bucket === 'within_7'
        ? 'warning'
        : bucket === 'within_30'
          ? 'secondary'
          : 'outline';
  return (
    <Badge variant={variant}>{bucket === 'expired' ? 'Expired' : daysLeftLabel(daysLeft)}</Badge>
  );
}
